import { render, staticRenderFns } from "./base-form-group.vue?vue&type=template&id=24f8e66a&scoped=true"
import script from "./base-form-group.ts?vue&type=script&lang=ts&external"
export * from "./base-form-group.ts?vue&type=script&lang=ts&external"
import style0 from "./base-form-group.vue?vue&type=style&index=0&id=24f8e66a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f8e66a",
  null
  
)

export default component.exports